import React from "react";
import { PATH } from "../../router/constants/Path";
import "consignment-stock/css/index.css";
import MobileHeaderAccount from "./MobileHeaderAccount";
import Left from "../../layout/components/Col/Left";
import NavAccountDesktop from "./NavAccountDesktop";
import useCustomerId from "../hooks/useCustomerId";

type Props = {
  path: PATH;
};

const Navigation: React.FC<Props> = ({ path }) => {
  const customerId = useCustomerId();

  return (
    <>
      <MobileHeaderAccount activeLi={path} customerId={customerId} />
      <Left>
        <NavAccountDesktop activeLi={path} customerId={customerId} />
      </Left>
    </>
  );
};

export default Navigation;
